<template>
    <div class="salary_box">
        <div class="salary">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">上传时间</div>
                        <el-date-picker size="small" v-model="searchUploadTime" type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" style="width: 392px;"></el-date-picker>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                    <div class="upload_btn" :loading="downloadLoading" @click="fnExportExcel"><span>导出工资表模板</span></div>
                    <el-upload style="display: inline-block;" class="upload" :show-file-list="false" action=""
                        :multiple="false"
                        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :on-change="importExcel" :limit="1">
                        <div class="upload_btn orange" :loading="downloadLoading"><span>导入工资表</span></div>
                    </el-upload>
                </div>
                <div class="box_line_other">工资管理</div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">表名</div>
                    <div class="title_item">详情</div>
                    <div class="title_item">上传时间</div>
                    <div class="title_item">下载地址</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="tableData">
                            <div class="box_line" v-for="(item, index) in tableData" :key="index">
                                <div class="list_item" :title="item.name">
                                    <span>{{ item.name }}</span>
                                </div>
                                <div class="list_item" @click="fnShowDetails(item.personnel_details)">
                                    <span
                                        :title="fnDetailsFormat(item.details)">{{ fnDetailsFormat(item.details) }}</span>
                                </div>
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div>
                                        <div class="search-btn" @click="download(item.excel_url)"><span>下载</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :page-sizes="pageSizes" :page-size="pageSize" :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" />
            </div>
            <!-- 发放工资弹窗 -->
            <div class="dialog_salary" v-if="isShowUploadResult">
                <el-dialog title="工资信息" :custom-class="'animate__animated animate__fadeIn'" :modal="false" center
                    :visible.sync="isShowUploadResult" top="6vh" width="90%">
                    <div style="padding-bottom: 10px;font-size: 16px;color: #FFFFFF;">
                        <span>总人员数: {{ excelData.length }}人;</span>
                    </div>
                    <el-table :data="excelData" height="55vh" border width="96%"
                        @selection-change="handleSelectionChange" :highlight-current-row="false"
                        :cell-style=" () => { return 'color: rgba(255,255,255,0.8);border-color: rgba(255,255,255,0.2)'; }"
                        :header-cell-style="() => { return 'backgroundColor: rgba(49, 88, 128, 0.2);color: #fff;border-color: rgba(255,255,255,0.2);';}">
                        <el-table-column type="selection" width="55"></el-table-column>
                        <el-table-column prop="personnel_id" label="人员编号" align="center"></el-table-column>
                        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="department" show-overflow-tooltip label="所属班组"
                            align="center"></el-table-column>
                        <el-table-column prop="idcard" width="180px" label="身份证号" align="center"></el-table-column>
                        <el-table-column prop="attendanceDay" label="出勤天数" align="center"></el-table-column>
                        <el-table-column prop="actualAmount" label="*实发金额" align="center"></el-table-column>
                        <el-table-column prop="totalPayAmount" label="*应发金额" align="center"></el-table-column>
                        <el-table-column prop="garnishedWages" label="*当月扣发工资金额" align="center"></el-table-column>
                        <el-table-column prop="isBackPay" label="*是否补发 (是 | 否)" align="center"></el-table-column>
                        <el-table-column prop="balanceDate" width="100px" label="*发放日期"
                            align="center"></el-table-column>
                        <el-table-column prop="payMonth" label="*发放工资年月" align="center"></el-table-column>
                        <el-table-column prop="settlementAmount" label="*结算量" align="center"></el-table-column>
                        <el-table-column prop="financialMark" label="*财务确认标识 (已确认 | 未确认)"
                            align="center"></el-table-column>
                        <el-table-column prop="personalMark" label="*个人核对标识 (已核对 | 未核对)"
                            align="center"></el-table-column>
                        <el-table-column prop="bank" label="*所属银行" align="center"></el-table-column>
                        <el-table-column prop="accountName" show-overflow-tooltip label="*开户名称"
                            align="center"></el-table-column>
                        <el-table-column prop="accountNo" width="130px" label="*开户账号" align="center"></el-table-column>
                        <el-table-column prop="bankName" show-overflow-tooltip label="*开户银行支行名称"
                            align="center"></el-table-column>
                        <el-table-column prop="backPayMonth" label="补发月份" align="center"></el-table-column>
                        <el-table-column prop="livingFee" label="生活费(元)" align="center"></el-table-column>
                        <el-table-column prop="chargeLossTime" label="误工费" align="center"></el-table-column>
                        <el-table-column prop="totalProductiveHours" label="总工时" align="center"></el-table-column>
                        <el-table-column prop="submitBatchNo" label="提交批次" align="center"></el-table-column>
                        <el-table-column prop="submitApply" label="提请平台立即代发" align="center"></el-table-column>
                        <el-table-column prop="extFieldOne" label="特定银行扩展字段1" align="center"></el-table-column>
                        <el-table-column prop="extFieldTwo" label="特定银行扩展字段2" align="center"></el-table-column>
                        <el-table-column prop="payrollVoucher" label="工资清册凭证" align="center"></el-table-column>
                        <el-table-column prop="payStatus" label="发放状态" align="center"></el-table-column>
                        <el-table-column prop="accountType" label="开户类型 (专户 | 一般户)" align="center"></el-table-column>
                        <el-table-column prop="specialAccountType" label="专户类型 (实体户 | 虚拟户)"
                            align="center"></el-table-column>
                        <el-table-column prop="salaryPayChannel" label="工资发放渠道 (第三方 | 银行)"
                            align="center"></el-table-column>
                        <el-table-column prop="accountBalance" label="账户余额(元)" align="center"></el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <!-- <div class="search-btn" @click="fnUploadSalaryToGzs"><span>上传至贵州省人社厅平台</span></div> -->
                            <div class="search-btn" @click="fnGetPassword"><span>上传至贵州省人社厅平台</span></div>
                            <div class="search-btn red" @click="isShowUploadResult = false"><span>关闭</span></div>
                        </div>
                    </span>
                </el-dialog>
            </div>
            <!-- 详情-详细列表 -->
            <div class="dialog_infos" v-if="showErrorInfo">
                <el-dialog title="详细列表" :custom-class="'animate__animated animate__fadeIn'" :modal="false"
                    :visible.sync="showErrorInfo" center>
                    <!--                    <div class="texts">共 {{errorInfoList.length}} 人;发放成功 {{ successCount }} 人; 发放失败 {{ errorCount }} 人;
                    </div> -->

                    <div class="texts">共 {{errorInfoList.length}} 人</div>
                    <div class="cont_list">
                        <div class="list_title">
                            <div class="title_item">人员详情</div>
                            <div class="title_item">发放状态</div>
                            <div class="title_item">发放详情</div>
                        </div>
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="errorInfoList">
                                    <div class="box_line" v-for="(item, index) in errorInfoList" :key="index">
                                        <div class="list_item" :title="item.result">
                                            <span>{{ item.result }}</span>
                                        </div>
                                        <div class="list_item" :class="item.resultState=='发放失败'?'red':''"
                                            :title="item.resultState">
                                            <span>{{ item.resultState }}</span>
                                        </div>
                                        <div class="list_item" :class="item.resultState=='发放失败'?'red':''"
                                            :title="item.resultMsg">

                                            <span v-if="item.resultMsg">{{ item.resultMsg }}</span>

                                            <div v-else class="search-btn"
                                                @click="fnGetUploadResult(index,item.submitBatchNo,item.idcard)">查询
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showErrorInfo = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 上传人员时进度条 -->
            <div class="progress" v-if="showProgress">
                <div class="progress-box">
                    <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
                    <span>{{ progressText }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    import {
        getUserInfo
    } from '@/utils/auth';
    import {
        fnRequestPlatform,
        fnUpload
    } from '@/utils/upload';
    import XLSX from 'xlsx';
    import {
        Loading
    } from 'element-ui';
    import moment from 'moment';
    import md5 from 'js-md5';
    export default {
        data() {
            return {
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                isShowUploadResult: false, // 上传结果弹窗
                searchUploadTime: [], // 时间插件 -> 上传时间
                searchtime: '', // 上传时间
                tableData: [], // 页面列表数据
                excelData: [], // 表格数据
                selectedUploadPersonnel: [], // 选择的文件
                excelFile: {}, // 导入文件
                flieName: '', // 导入表名
                downloadLoading: false,
                showProgress: false, // 显示进度条
                percentage: 0, // 进度条
                progressText: '上传中…',
                errorInfoList: [], // 上传失败信息列表
                showErrorInfo: false, // 详情列表弹窗
                resultDetails: [], // 保存每条成功存储成功的数据
                personnelDetails: {}, // 保存每条成功存储成功的数据
                successCount: 0,
                errorCount: 0,
            };
        },
        created() {
            this.fnInit();
        },
        methods: {
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnGetSalary({
                    page: this.currentPage,
                    size: this.pageSize,
                    create_at: this.searchtime
                }, res => {
                    this.tableData = res.data.query;
                    this.pageTotal = res.data.count;
                });
            },
            // 查看详情
            fnShowDetails(_data) {
                _data = JSON.parse(_data);
                let _arr = []
                // 循环比对 提交批次
                for (let i in _data) {
                    for (let j in _data[i]) {
                        let _obj = {
                            result: '姓名：' + _data[i][j].name + '，身份证号：' + _data[i][j].idcard,
                            resultState: '暂无',
                            results: null,
                            resultMsg: '',
                            submitBatchNo: i,
                            idcard: _data[i][j].idcard
                        };
                        _arr.push(_obj)
                    }
                    // this.fnGetUploadResult(i);
                }
                this.errorInfoList = _arr;
                this.showErrorInfo = true;
            },
            // 比对工资的 提交批次 获取每个人的状态
            fnGetUploadResult(index, _number, _idcard) {



                fnRequestPlatform({
                    url: '/Gzs/getProvideSalaryInfo',
                    method: 'POST',
                    data: {
                        carry: _number + '&idCard=' + _idcard
                    }
                }, res => {

                    console.log(res);

                    if (res.code !== 1) {
                        this.$message.error('贵州人社平台反馈未知错误，请稍后重试');
                        return
                    }

                    let _resData = res.data;

                    if (_resData.hasOwnProperty("message")) {
                        this.$message.error('贵州人社平台反馈错误，请稍后重试，详情：' + _resData.message);
                        return
                    }

                    let _obj = {
                        result: this.errorInfoList[index].result,
                        resultState: this.fnGetResult(_resData[0].result),
                        results: _resData[0].result,
                        resultMsg: _resData[0].retMsg,
                        idcard: this.errorInfoList[index].idcard
                    };
                    console.log(_obj);
                    this.$set(this.errorInfoList, index, _obj);

                    // let _resData = res.data;
                    // for (let j in _resData) {
                    //     for (let i in this.errorInfoList) {
                    //         if (this.errorInfoList[i].idcard.toUpperCase() == _resData[j].idCard
                    //             .toUpperCase()) {
                    //             let _obj = {
                    //                 result: this.errorInfoList[i].result,
                    //                 resultState: this.fnGetResult(_resData[j].result),
                    //                 results: _resData[j].result,
                    //                 resultMsg: _resData[j].retMsg,
                    //                 idcard: this.errorInfoList[i].idcard
                    //             };
                    //             this.$set(this.errorInfoList, i, _obj);
                    //             break;
                    //         }
                    //     }
                    // }
                    // let _arrSuss = [] // 除了状态为 -- 提交失败(2) / 发放失败(6)
                    // let _arrErr = [] // 状态为 -- 提交失败(2) / 发放失败(6)
                    // let _successCount = 0
                    // let _errorCount = 0
                    // for (let k in this.errorInfoList) {
                    //     if (this.errorInfoList[k].results == 6) { // 发放失败
                    //         _errorCount += 1
                    //     }
                    //     if (this.errorInfoList[k].results == 5) { // 发放成功
                    //         _successCount += 1
                    //     }
                    //     if (this.errorInfoList[k].results == 2 || this.errorInfoList[k].results == 6) {
                    //         _arrErr.push(this.errorInfoList[k])
                    //     } else {
                    //         _arrSuss.push(this.errorInfoList[k])
                    //     }
                    // }
                    // let arr = _arrErr.concat(_arrSuss)
                    // this.errorInfoList = arr
                    // this.successCount = _successCount
                    // this.errorCount = _errorCount
                });
            },
            fnGetResult(_state) {
                switch (Number(_state)) {
                    case 0:
                        return '未提交';
                    case 1:
                        return '提交成功';
                    case 2:
                        return '提交失败';
                    case 3:
                        return '等待银行授权';
                    case 4:
                        return '银行处理中';
                    case 5:
                        return '发放成功';
                    case 6:
                        return '发放失败';
                    default:
                        return '暂无';
                }
            },
            // 处理页面详情数据
            fnDetailsFormat(_data) {
                _data = JSON.parse(_data);
                let _arr = [];
                _data.forEach(_item => {
                    _arr.push(_item.data);
                });
                return _arr.join(',');
            },
            // 下载
            download(val) {
                location.href = val;
            },
            // 获取上传时选中的人员信息
            handleSelectionChange(_val) {
                this.selectedUploadPersonnel = _val;
            },
            // 上传工资之前 匹配密码
            fnGetPassword() {
                let _that = this;
                let _selected = _that.selectedUploadPersonnel;
                if (!_selected.length) {
                    _that.$message.warning('请选择需要上传的人员');
                    return;
                }
                let pass = md5(String(getUserInfo().id))
                _that.$prompt(`请输入密码:`, `友情提示`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'password',
                    closeOnClickModal: false,
                    inputErrorMessage: '密码不能为空'
                }).then(({
                    value
                }) => {
                    if (pass.toUpperCase() === value.toUpperCase()) {
                        // 密码一致
                        _that.fnUploadSalaryToGzs()
                    } else {
                        // 密码不一致
                        _that.$message.warning('密码错误，请联系技术团队获取!');
                    }
                })
            },
            // 上传工资信息至贵州平台
            fnUploadSalaryToGzs() {
                let _that = this;
                let _selected = _that.selectedUploadPersonnel;
                if (!_selected.length) {
                    _that.$message.warning('请选择需要上传的人员');
                    return;
                }
                _that.$confirm('上传过程中请勿关闭页面', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'Warning',
                        center: true
                    }).then(() => {
                        let _percentage = 0;
                        _that.percentage = 0;
                        _that.progressText = '上传中…';
                        _that.showProgress = true;
                        let _start = 0;
                        let _num = 100; // 每次上传的数据条数
                        let _count = _selected.length; // 总条数
                        let _tenArr = [];
                        let _tenArrIndex = 0;
                        let _uploadResult = [];
                        let _result = new Array(Math.ceil(_count / _num));
                        // 进行循环
                        while (_start < _count) {
                            _result[_tenArrIndex++] = _selected.slice(_start, (_start += _num));
                        }
                        let _length = _result.length;
                        let _tage = Number(APP.fnTwoFloat(100 / _length)); // 进度条分段长度
                        // 循环设置 数据 批次号
                        for (let i = 0; i < _result.length; i++) {
                            let submitBatchNo = getUserInfo().id + '' + APP.fnGetRandomNum(6) + '' + new Date()
                                .getTime();
                            let _detail = [];
                            for (let j = 0; j < _result[i].length; j++) {
                                _result[i][j].submitBatchNo = submitBatchNo;
                                _detail.push({
                                    name: _result[i][j].name,
                                    idcard: _result[i][j].idcard
                                });
                            }
                            _that.personnelDetails[submitBatchNo] = _detail;
                        }
                        _fn();

                        function _fn() {
                            if (_result.length > 0) {
                                fnRequestPlatform({
                                        url: '/Gzs/uploadProvideSalaryInfo',
                                        method: 'POST',
                                        data: {
                                            carry: JSON.stringify(_result[0])
                                        }
                                    },
                                    res => {
                                        _percentage += _tage
                                        _that.percentage = Number(APP.fnTwoFloat(_percentage)); // 加载进度条
                                        _that.resultDetails.push({
                                            code: res.code,
                                            data: res.data
                                        });
                                        if (res.code == 0) {
                                            _uploadResult.push({
                                                info: _result[0],
                                                code: res.code,
                                                result: res.data
                                            });
                                        }
                                        _result.splice(0, 1);
                                        _fn();
                                    });
                            } else {
                                _that.percentage = 100;
                                _that.progressText = '已完成';
                                setTimeout(() => {
                                    _that.showProgress = false;
                                    if (_uploadResult.length) {
                                        _that.errorInfoList = _uploadResult;
                                        _that.isShowUploadResult = false;
                                        _that.showErrorInfo = true;
                                    } else {
                                        _that.isShowUploadResult = false;
                                        _that.$message.success('上传人员至贵州省人社厅成功');
                                    }
                                    // 上传文件
                                    _that.fnUploadSalaryInfo();
                                }, 800);
                            }
                        }
                    })
                    .catch(() => {
                        _that.isShowUploadResult = false;
                    });
            },
            // 上传文件 到自己平台
            fnUploadSalaryInfo() {
                let formData = new FormData();
                formData.append('file', this.excelFile);
                formData.append('type', 'xlsx');
                fnUpload(formData, res => {
                    let excel_url = res.data.file_url;
                    let obj = {
                        name: this.flieName,
                        excel_url: excel_url,
                        details: JSON.stringify(this.resultDetails),
                        personnel_details: JSON.stringify(this.personnelDetails)
                    };
                    request({
                        url: 'salary/saveSalary',
                        method: 'POST',
                        data: obj
                    }).then(res => {
                        this.resultDetails = [];
                        this.personnelDetails = {};
                        this.fnInit();
                    }).catch(err => {
                        this.resultDetails = [];
                        this.personnelDetails = {};
                        this.$message.error(err.data);
                    });
                });
            },
            // 搜索
            fnSearch() {
                if (this.searchUploadTime.length > 0) {
                    this.searchtime = this.searchUploadTime[0] + ',' + this.searchUploadTime[1];
                } else {
                    this.searchtime = '';
                }
                this.fnGetSalary({
                    page: this.currentPage,
                    size: this.pageSize,
                    create_at: this.searchtime
                }, res => {
                    this.tableData = res.data.query;
                    this.pageTotal = res.data.count;
                });
            },
            // 初始化 -> 获取页面列表项
            fnInit() {
                this.fnGetSalary({
                    page: this.currentPage,
                    size: this.pageSize
                }, res => {
                    this.tableData = res.data.query;
                    this.pageTotal = res.data.count;
                });
            },
            fnGetSalary(_obj, _cb) {
                request({
                    url: 'salary/getSalary',
                    method: 'GET',
                    params: _obj
                }).then(res => {
                    _cb && _cb(res);
                }).catch(err => {
                    this.$message.error(err.data);
                });
            },
            // 导出excel
            fnExportExcel() {
                let _that = this;
                request({
                    url: 'project_gzs/getUnit',
                    method: 'GET',
                    params: {
                        type: '3' // 获取工资专户信息
                    }
                }).then(result => {
                    if (result.code == APP.HTTP_STATUS.SUCCESS) {
                        let _wageAccount = result.data[0];
                        request({
                            url: 'salary_gzs/getSalaryTemplate',
                            method: 'GET'
                        }).then(res => {
                            if (res.code === APP.HTTP_STATUS.SUCCESS) {
                                let _date = new Date();
                                let _data = res.data;
                                let _excelData = []; // 建议数据
                                let _defaultExcelData = []; // 默认数据
                                let _countData = {};
                                let _defaultCountData = {};
                                if (_data.length > 0) {
                                    for (let i = 0; i < _data.length; i++) {
                                        let _pay = APP.fnGetRandom_public(3000, 8000);
                                        let _index = _data[i].department.indexOf('#');
                                        let _departmentName1 = _data[i].department ? _data[i].department
                                            .slice(_index + 1) : _data[i].department;
                                        let _departmentName2 = _departmentName1.replace(/\[/g, '【');
                                        let _departmentName3 = _departmentName2.replace(/\]/g, '】');
                                        let _departmentName4 = _departmentName3.replace(/\:/g, '：');
                                        let _departmentName5 = _departmentName4.replace(/\*/g, '✲');
                                        let _departmentName6 = _departmentName5.replace(/\?/g, '？');
                                        let _departmentName7 = _departmentName6.replace(/\//g, '|');
                                        let _departmentName = _departmentName7.replace(/\\/g, '|');
                                        _excelData = {
                                            personnel_id: _data[i].id, // 人员id
                                            name: _data[i].name, // 姓名
                                            department: _departmentName, // 班组
                                            idcard: _data[i].idcard, // 身份证号
                                            payrollBank: _data[i].payrollBank, // 工人工资卡所属银行
                                            payRollBankName: _data[i]
                                                .payRollBankName, // 工人工资卡所属银行支行
                                            payRollBankCardNum: _data[i]
                                                .payRollBankCardNum, // 工人工资卡银行卡号
                                            attendanceDay: APP.fnGetRandom_public(20, 28), // 出勤天数
                                            actualAmount: _pay, // *实发金额
                                            totalPayAmount: _pay, // *应发金额
                                            garnishedWages: '0', // *应发金额
                                            isBackPay: '否', // *是否补发
                                            backPayMonth: '', // 补发月份
                                            balanceDate: _date.Format('yyyy-MM-dd'), // *发放日期
                                            payMonth: _date.Format('yyyyMM'), // *发放工资年月
                                            settlementAmount: '1', // *结算量
                                            livingFee: '', // 生活费(元)
                                            chargeLossTime: '', // 误工费
                                            financialMark: '已确认', // *财务确认标识 (已确认 | 未确认)
                                            personalMark: '已核对', // *个人核对标识 (已核对 | 未核对)
                                            totalProductiveHours: '', // 总工时
                                            // 工资代发通道信息
                                            submitBatchNo: '', // 提交批次
                                            submitApply: '', // 提请平台立即代发
                                            extFieldOne: '', // 特定银行扩展字段1
                                            extFieldTwo: '', // 特定银行扩展字段2
                                            // 工资发放附件信息
                                            payrollVoucher: '', // 工资清册凭证
                                            payStatus: '', // 发放状态
                                            // *工资专户信息
                                            bank: _wageAccount['bank'] || '', // *所属银行
                                            accountName: _wageAccount['accountName'] || '', // *开户名称
                                            accountType: _wageAccount['accountType'] ||
                                                '专户', // 开户类型 (专户 | 一般户)
                                            specialAccountType: _wageAccount[
                                                'specialAccountType'] || '实体户', // 专户类型 (实体户 | 虚拟户)
                                            salaryPayChannel: _wageAccount['salaryPayChannel'] ||
                                                '银行', // 工资发放渠道 (第三方 | 银行)
                                            accountNo: _wageAccount['accountNo'] || '', // *开户账号
                                            bankName: _wageAccount['bankName'] || '', // *开户银行支行名称
                                            accountBalance: _wageAccount['accountBalance'] ||
                                                '' // 账户余额(元)
                                        };
                                        _defaultExcelData = {
                                            personnel_id: _data[i].id, // 人员id
                                            name: _data[i].name, // 姓名
                                            department: _departmentName, // 班组
                                            idcard: _data[i].idcard, // 身份证号
                                            payrollBank: _data[i].payrollBank, // 工人工资卡所属银行
                                            payRollBankName: _data[i]
                                                .payRollBankName, // 工人工资卡所属银行支行
                                            payRollBankCardNum: _data[i]
                                                .payRollBankCardNum, // 工人工资卡银行卡号
                                            attendanceDay: '', // 出勤天数
                                            actualAmount: '', // *实发金额
                                            totalPayAmount: '', // *应发金额
                                            garnishedWages: '', // *当月扣发工资金额
                                            isBackPay: '', // *是否补发
                                            backPayMonth: '', // 补发月份
                                            balanceDate: _date.Format('yyyy-MM-dd'), // *发放日期
                                            payMonth: _date.Format('yyyyMM'), // *发放工资年月
                                            settlementAmount: '', // *结算量
                                            livingFee: '', // 生活费(元)
                                            chargeLossTime: '', // 误工费
                                            financialMark: '', // *财务确认标识 (已确认 | 未确认)
                                            personalMark: '', // *个人核对标识 (已核对 | 未核对)
                                            totalProductiveHours: '', // 总工时
                                            // 工资代发通道信息
                                            submitBatchNo: '', // 提交批次
                                            submitApply: '', // 提请平台立即代发
                                            extFieldOne: '', // 特定银行扩展字段1
                                            extFieldTwo: '', // 特定银行扩展字段2
                                            // 工资发放附件信息
                                            payrollVoucher: '', // 工资清册凭证
                                            payStatus: '', // 发放状态
                                            // *工资专户信息
                                            bank: _wageAccount['bank'] || '', // *所属银行
                                            accountName: _wageAccount['accountName'] || '', // *开户名称
                                            accountType: _wageAccount['accountType'] ||
                                                '', // 开户类型 (专户 | 一般户)
                                            specialAccountType: _wageAccount[
                                                'specialAccountType'] || '', // 专户类型 (实体户 | 虚拟户)
                                            salaryPayChannel: _wageAccount['salaryPayChannel'] ||
                                                '', // 工资发放渠道 (第三方 | 银行)
                                            accountNo: _wageAccount['accountNo'] || '', // *开户账号
                                            bankName: _wageAccount['bankName'] || '', // *开户银行支行名称
                                            accountBalance: _wageAccount['accountBalance'] ||
                                                '' // 账户余额(元)
                                        };
                                        if (_countData[_departmentName]) {
                                            _countData[_departmentName].push(_excelData);
                                        } else {
                                            _countData[_departmentName] = [_excelData];
                                        }
                                        if (_defaultCountData[_departmentName]) {
                                            _defaultCountData[_departmentName].push(_defaultExcelData);
                                        } else {
                                            _defaultCountData[_departmentName] = [_defaultExcelData];
                                        }
                                    }
                                } else {
                                    let _departmentName = '';
                                    _excelData = {
                                        personnel_id: '', // 人员id
                                        name: '', // 姓名
                                        department: _departmentName, // 班组
                                        idcard: '', // 身份证号
                                        payrollBank: '', // 工人工资卡所属银行
                                        payRollBankName: '', // 工人工资卡所属银行支行
                                        payRollBankCardNum: '', // 工人工资卡银行卡号
                                        attendanceDay: '', // 出勤天数
                                        actualAmount: '', // *实发金额
                                        totalPayAmount: '', // *应发金额
                                        garnishedWages: '', // *当月扣发工资金额
                                        isBackPay: '', // *是否补发
                                        backPayMonth: '', // 补发月份
                                        balanceDate: '', // *发放日期
                                        payMonth: '', // *发放工资年月
                                        settlementAmount: '', // *结算量
                                        livingFee: '', // 生活费(元)
                                        chargeLossTime: '', // 误工费
                                        financialMark: '', // *财务确认标识 (已确认 | 未确认)
                                        personalMark: '', // *个人核对标识 (已核对 | 未核对)
                                        totalProductiveHours: '', // 总工时
                                        // 工资代发通道信息
                                        submitBatchNo: '', // 提交批次
                                        submitApply: '', // 提请平台立即代发
                                        extFieldOne: '', // 特定银行扩展字段1
                                        extFieldTwo: '', // 特定银行扩展字段2
                                        // 工资发放附件信息
                                        payrollVoucher: '', // 工资清册凭证
                                        payStatus: '', // 发放状态
                                        // *工资专户信息
                                        bank: '', // *所属银行
                                        accountName: '', // *开户名称
                                        accountType: '', // 开户类型 (专户 | 一般户)
                                        specialAccountType: '', // 专户类型 (实体户 | 虚拟户)
                                        salaryPayChannel: '', // 工资发放渠道 (第三方 | 银行)
                                        accountNo: '', // *开户账号
                                        bankName: '', // *开户银行支行名称
                                        accountBalance: '' // 账户余额(元)
                                    };
                                    _defaultExcelData = {
                                        personnel_id: '', // 人员id
                                        name: '', // 姓名
                                        department: '', // 班组
                                        idcard: '', // 身份证号
                                        payrollBank: '', // 工人工资卡所属银行
                                        payRollBankName: '', // 工人工资卡所属银行支行
                                        payRollBankCardNum: '', // 工人工资卡银行卡号
                                        attendanceDay: '', // 出勤天数
                                        actualAmount: '', // *实发金额
                                        totalPayAmount: '', // *应发金额
                                        garnishedWages: '', // *当月扣发工资金额
                                        isBackPay: '', // *是否补发
                                        backPayMonth: '', // 补发月份
                                        balanceDate: '', // *发放日期
                                        payMonth: '', // *发放工资年月
                                        settlementAmount: '', // *结算量
                                        livingFee: '', // 生活费(元)
                                        chargeLossTime: '', // 误工费
                                        financialMark: '', // *财务确认标识 (已确认 | 未确认)
                                        personalMark: '', // *个人核对标识 (已核对 | 未核对)
                                        totalProductiveHours: '', // 总工时
                                        // 工资代发通道信息
                                        submitBatchNo: '', // 提交批次
                                        submitApply: '', // 提请平台立即代发
                                        extFieldOne: '', // 特定银行扩展字段1
                                        extFieldTwo: '', // 特定银行扩展字段2
                                        // 工资发放附件信息
                                        payrollVoucher: '', // 工资清册凭证
                                        payStatus: '', // 发放状态
                                        // *工资专户信息
                                        bank: '', // *所属银行
                                        accountName: '', // *开户名称
                                        accountType: '', // 开户类型 (专户 | 一般户)
                                        specialAccountType: '', // 专户类型 (实体户 | 虚拟户)
                                        salaryPayChannel: '', // 工资发放渠道 (第三方 | 银行)
                                        accountNo: '', // *开户账号
                                        bankName: '', // *开户银行支行名称
                                        accountBalance: '' // 账户余额(元)
                                    };
                                    _countData[_departmentName] = [_excelData];
                                    _defaultCountData[_departmentName] = [_defaultExcelData];
                                }
                                const {
                                    export_json_to_excel_arr
                                } = require('@/vendor/Export2Excel.js');
                                const tHeader = [
                                    '人员编号',
                                    '姓名',
                                    '所属班组',
                                    '身份证号',
                                    '工人工资卡所属银行',
                                    '工人工资卡所属银行支行',
                                    '工人工资卡银行卡号',
                                    '出勤天数',
                                    '*实发金额',
                                    '*应发金额',
                                    '*当月扣发工资金额',
                                    '*是否补发 (是 | 否)',
                                    '*发放日期',
                                    '*发放工资年月',
                                    '*结算量',
                                    '*财务确认标识 (已确认 | 未确认)',
                                    '*个人核对标识 (已核对 | 未核对)',
                                    '*所属银行',
                                    '*开户名称',
                                    '*开户账号',
                                    '*开户银行支行名称',
                                    '补发月份',
                                    '生活费(元)',
                                    '误工费',
                                    '总工时',
                                    '提交批次',
                                    '提请平台立即代发',
                                    '特定银行扩展字段1',
                                    '特定银行扩展字段2',
                                    '工资清册凭证',
                                    '发放状态',
                                    '开户类型 (专户 | 一般户)',
                                    '专户类型 (实体户 | 虚拟户)',
                                    '工资发放渠道 (第三方 | 银行)',
                                    '账户余额(元)'
                                ];
                                const filterVal = [
                                    'personnel_id',
                                    'name',
                                    'department',
                                    'idcard',
                                    'payrollBank',
                                    'payRollBankName',
                                    'payRollBankCardNum',
                                    'attendanceDay',
                                    'actualAmount',
                                    'totalPayAmount',
                                    'garnishedWages',
                                    'isBackPay',
                                    'balanceDate',
                                    'payMonth',
                                    'settlementAmount',
                                    'financialMark',
                                    'personalMark',
                                    'bank',
                                    'accountName',
                                    'accountNo',
                                    'bankName',
                                    'backPayMonth',
                                    'livingFee',
                                    'chargeLossTime',
                                    'totalProductiveHours',
                                    'submitBatchNo',
                                    'submitApply',
                                    'extFieldOne',
                                    'extFieldTwo',
                                    'payrollVoucher',
                                    'payStatus',
                                    'accountType',
                                    'specialAccountType',
                                    'salaryPayChannel',
                                    'accountBalance'
                                ];
                                const _filename = getUserInfo().name + '-' + new Date().Format(
                                    'yyyy-MM') + '工资信息';
                                let _sheetname = [];
                                let _tHeaderArr = [];
                                let _dataArr = [];
                                this.$confirm('是否生成建议数据', '提示', {
                                    confirmButtonText: '是',
                                    cancelButtonText: '否',
                                    center: true
                                }).then(() => {
                                    for (let _key in _countData) {
                                        _sheetname.push(_key);
                                        _tHeaderArr.push(tHeader);
                                        _dataArr.push(_that.formatJson(filterVal, _countData[
                                            _key]));
                                    }
                                    export_json_to_excel_arr({
                                        header: _tHeaderArr,
                                        data: _dataArr,
                                        sheetname: _sheetname,
                                        filename: _filename
                                    });
                                }).catch(() => {
                                    for (let _key in _defaultCountData) {
                                        _sheetname.push(_key);
                                        _tHeaderArr.push(tHeader);
                                        _dataArr.push(_that.formatJson(filterVal,
                                            _defaultCountData[_key]));
                                    }
                                    export_json_to_excel_arr({
                                        header: _tHeaderArr,
                                        data: _dataArr,
                                        sheetname: _sheetname,
                                        filename: _filename
                                    });
                                });
                            } else {
                                _that.$message.error(res);
                            }
                        }).catch(err => {
                            _that.$message.error(err);
                        });
                    } else {
                        _that.$message.error(result);
                    }
                }).catch(err => {
                    _that.$message.error(err);
                });
            },
            // 导入表格
            importExcel(param) {
                let _this = this;
                _this.excelFile = param.raw;
                _this.flieName = param.name;
                _this.file2Xce(param).then(item => {

                    console.log(item)

                    if (item && item.length > 0) {
                        let arr = [];
                        item.forEach(child => {
                            child['sheet'].forEach(_item => {
                                let obj = {};
                                obj.personnel_id = _item['人员编号'] ? _item['人员编号'] : '';
                                obj.name = _item['姓名'] ? _item['姓名'] : '';
                                obj.department = _item['所属班组'] ? _item['所属班组'] : '';
                                obj.idcard = _item['身份证号'] ? _item['身份证号'] : '';
                                obj.attendanceDay = _item['出勤天数'] ? _item['出勤天数'] : '';
                                obj.actualAmount = _item['*实发金额'] ? _item['*实发金额'] : '';
                                obj.totalPayAmount = _item['*应发金额'] ? _item['*应发金额'] : '';
                                obj.garnishedWages = _item['*当月扣发工资金额'] ? _item['*当月扣发工资金额'] :
                                    '';
                                obj.isBackPay = _item['*是否补发 (是 | 否)'] ? _item[
                                    '*是否补发 (是 | 否)'] : '';
                                obj.balanceDate = _item['*发放日期'] ? _this.dateFormat(_item[
                                    '*发放日期']) : '';
                                obj.payMonth = _item['*发放工资年月'] ? _item['*发放工资年月'] : '';
                                obj.settlementAmount = _item['*结算量'] ? _item['*结算量'] : '';
                                obj.financialMark = _item['*财务确认标识 (已确认 | 未确认)'] ? _item[
                                    '*财务确认标识 (已确认 | 未确认)'] : '';
                                obj.personalMark = _item['*个人核对标识 (已核对 | 未核对)'] ? _item[
                                    '*个人核对标识 (已核对 | 未核对)'] : '';
                                obj.bank = _item['*所属银行'] ? _item['*所属银行'] : '';
                                obj.accountName = _item['*开户名称'] ? _item['*开户名称'] : '';
                                obj.accountNo = _item['*开户账号'] ? _item['*开户账号'] : '';
                                obj.bankName = _item['*开户银行支行名称'] ? _item['*开户银行支行名称'] : '';
                                obj.backPayMonth = _item['补发月份'] ? _item['补发月份'] : '';
                                obj.livingFee = _item['生活费(元)'] ? _item['生活费(元)'] : '';
                                obj.chargeLossTime = _item['误工费'] ? _item['误工费'] : '';
                                obj.totalProductiveHours = _item['总工时'] ? _item['总工时'] : '';
                                obj.submitBatchNo = _item['提交批次'] ? _item['提交批次'] : '';
                                obj.submitApply = _item['提请平台立即代发'] ? _item['提请平台立即代发'] : '';
                                obj.extFieldOne = _item['特定银行扩展字段1'] ? _item['特定银行扩展字段1'] : '';
                                obj.extFieldTwo = _item['特定银行扩展字段2'] ? _item['特定银行扩展字段2'] : '';
                                obj.payrollVoucher = _item['工资清册凭证'] ? _item['工资清册凭证'] : '';
                                obj.payStatus = _item['发放状态'] ? _item['发放状态'] : '';
                                obj.accountType = _item['开户类型 (专户 | 一般户)'] ? _item[
                                    '开户类型 (专户 | 一般户)'] : '';
                                obj.specialAccountType = _item['专户类型 (实体户 | 虚拟户)'] ? _item[
                                    '专户类型 (实体户 | 虚拟户)'] : '';
                                obj.salaryPayChannel = _item['工资发放渠道 (第三方 | 银行)'] ? _item[
                                    '工资发放渠道 (第三方 | 银行)'] : '';
                                obj.accountBalance = _item['账户余额(元)'] ? _item['账户余额(元)'] : '';
                                arr.push(obj);
                            });
                        });
                        let _arr = []
                        for (let i in arr) {
                            if (arr[i].personnel_id) {
                                _arr.push(arr[i])
                            }
                        }
                        _this.excelData = _arr;
                        _this.isShowUploadResult = true;
                    }
                }).catch(error => {
                    loading.close();
                });
            },
            /**
             * 解析文件
             * @param {Object} file
             */
            file2Xce(file) {
                return new Promise(function(resolve, reject) {
                    const reader = new FileReader();
                    reader.onload = function(e) {
                        const data = e.target.result;
                        let excelData = XLSX.read(data, {
                            type: 'binary',
                            cellDates: true
                        });
                        const result = [];
                        excelData.SheetNames.forEach(sheetName => {
                            result.push({
                                sheetName: sheetName,
                                sheet: XLSX.utils.sheet_to_json(excelData.Sheets[sheetName])
                            });
                        });
                        resolve(result);
                    };
                    reader.readAsBinaryString(file.raw);
                });
            },
            // 数据json化
            formatJson(filterVal, jsonData) {
                return APP.formatJson(filterVal, jsonData);
            },
            // excel 日期转换
            dateFormat: function(date) {
                if (date === undefined) return '';
                return moment(date).format('YYYY-MM-DD');
            }
        }
    };
</script>

<style lang="scss" scoped type="text/scss">
    @import '~@/styles/mixin.scss';
.salary_box {
  width: 1920px;
  height: 858px;
  position: relative;
  overflow: hidden;
  .salary {
    position: absolute;
    left: 0;
    right: -20px;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.search_box {
  height: 98px;
  width: 1880px;
  margin-top: 24px;
  margin-left: 20px;
  @include flex-box(space-between, center, column);
  .box_line_other {
    width: 1880px;
    height: 66px;
    font-size: 32px;
    font-weight: bold;
    @include flex-box(center, center);
  }
  .box_line {
    width: 1880px;
    height: 32px;
    @include flex-box(flex-start, center);
    .line_input {
      min-width: 280px;
      height: 30px;
      margin-right: 10px;
      border-top-right-radius: 1px;
      border-bottom-right-radius: 1px;
      background-color: rgba(49, 88, 128, 0.4);
      @include flex-box(flex-start, center);
      .input_title {
        width: 69px;
        height: 30px;
        font-size: 14px;
        color: #9bf9fc;
        border-radius: 2px;
        background-color: rgba(155, 249, 252, 0.1);
        @include flex-box(center, center);
      }
    }
    .upload_btn {
      width: 160px;
      height: 32px;
      margin-left: 5px;
      background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
      background-size: 100% 100%;
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      cursor: pointer;
      @include flex-box(center, center);
      &.orange {
        background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
        background-size: 100% 100%;
      }
      span {
        margin-top: -5px;
      }
    }
  }
}
.cont_list {
  margin-top: 29px;
  margin-left: 28px;
  width: 1864px;
  height: 611px;
  border-radius: 10px;
  background-color: rgba(29, 68, 149, 0.1);
  .list_title {
    width: 1864px;
    height: 48px;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
    .title_item {
      height: 48px;
      @include flex-box(center, center);
      &:nth-child(1) {
        width: 444px;
        margin: 0 4px 0 40px;
      }
      &:nth-child(2) {
        width: 880px;
        margin-right: 4px;
      }
      &:nth-child(3) {
        width: 223px;
        margin-right: 4px;
      }
      &:nth-child(4) {
        width: 225px;
        margin-right: 40px;
      }
    }
  }
  .list_boxes {
    width: 1864px;
    height: 563px;
    position: relative;
    overflow: hidden;
    .list_box {
      position: absolute;
      left: 0;
      right: -25px;
      top: 0;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: auto;
      .box_line {
        width: 1784px;
        height: 70px;
        margin: 7px 0 0 40px;
        font-size: 16px;
        color: #ffffff;
        border-bottom: 1px dashed #1d4495;
        @include flex-box(flex-start, center);
        &:hover {
          background-color: rgba(49, 88, 128, 0.4);
        }
        .list_item {
          height: 70px;
          text-align: center;
          @include flex-box(center, center);
          &:nth-child(1) {
            width: 444px;
            margin-right: 2px;
          }
          &:nth-child(2) {
            width: 880px;
            margin-right: 2px;
          }
          &:nth-child(3) {
            width: 223px;
            margin-right: 2px;
          }
          &:nth-child(4) {
            width: 225px;
          }
          div {
            @include flex-box(center, center);
          }
          span {
            text-align: center;
            width: 100%;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}
.box_line {
  >>> .el-input__inner {
    width: 211px;
    height: 30px;
    border-radius: 2px;
    border: none;
    color: rgba(77, 180, 244, 0.7);
    background: transparent;
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-input__icon {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-range-input {
    background: transparent;
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-range-separator {
    color: rgba(77, 180, 244, 0.7);
  }
}
.progress {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.2);
	.progress-box {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 50%;
		text-align: center;
		@include prefixCss3(transform, translate(-50%, -50%));
		span {
			line-height: 30px;
			color: rgba(58,116,221,1);
			font-size: 16px;
		}
	}
}
.dialog_infos {
  // 按钮样式
  .btn_line {
    display: inline-block;
  }
  >>> .el-dialog {
    width: 1010px;
    height: 730px;
    margin-top: 18vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  .texts{
    font-size: 16px;
    height: 30px;
    line-height: 30px;
    color: #FFFFFF;
  }
  // 弹窗列表样式
  .cont_list {
    width: 960px;
    height: 525px;
    color: #ffffff;
    margin: 0;
    padding: 0;
    font-size: 16px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);
    .list_title {
      color: #4db4f4;
      width: 960px;
      height: 48px;
      background: url(../../../assets/img/per_list_bg.png) no-repeat;
      background-size: 100% 100%;
      @include flex-box(flex-start, center);
      .title_item {
        height: 48px;
        @include flex-box(center, center);
        &:nth-child(1) {
          width: 506px;
          margin: 0 4px 0 30px;
        }
        &:nth-child(2) {
          width: 126px;
          margin-right: 4px;
        }
        &:nth-child(3) {
          width: 260px;
          margin-right: 30px;
        }
      }
    }
    .list_boxes {
      width: 900px;
      height: 477px;
      margin-left: 30px;
      position: relative;
      overflow: hidden;
      .list_box {
        position: absolute;
        left: 0;
        right: -25px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
        .box_line {
          color: #4db4f4;
          width: 900px;
          height: 70px;
          margin: 5px 0 0 0;
          border-bottom: 1px dashed #1d4495;
          @include flex-box(flex-start, center);
          &:hover {
            background-color: rgba(49, 88, 128, 0.4);
          }
          .list_item {
            height: 70px;
            @include flex-box(center, center);
            &:nth-child(1) {
              width: 506px;
              margin-right: 4px;
            }
            &:nth-child(2) {
              width: 126px;
              margin-right: 4px;
            }
            &:nth-child(3) {
              width: 260px;
            }
            &.red{
              color: #F56C6C;
            }
            span {
              text-align: center;
              width: 100%;
              cursor: pointer;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
.dialog_salary {
  // 按钮样式
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  >>> .el-table,
  .el-table__expanded-cell {
    background-color: rgba(29, 68, 149, 0.1);
  }
  >>> .el-table {
    th,
    tr {
      background-color: transparent;
    }
  }
  >>> .hover-row > td {
    color: #000 !important;
  }
  >>> .el-table__body {
    tr:hover > td {
      background-color: rgba(49, 88, 128, 0.4);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Salary/salaryGzs/index.vue